/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BaseResponse } from '../../models/base-response';
import { BookingItem } from '../../models/booking-item';

export interface BookingControllerDeleteBooking$Params {
  booking_identifier: string;
}

export function bookingControllerDeleteBooking(http: HttpClient, rootUrl: string, params: BookingControllerDeleteBooking$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: BookingItem;
}>> {
  const rb = new RequestBuilder(rootUrl, bookingControllerDeleteBooking.PATH, 'delete');
  if (params) {
    rb.path('booking_identifier', params.booking_identifier, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BaseResponse & {
      'data'?: BookingItem;
      }>;
    })
  );
}

bookingControllerDeleteBooking.PATH = '/booking/{booking_identifier}';
